import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-most-common-chart',
  templateUrl: './most-common-chart.component.html',
  styleUrls: ['./most-common-chart.component.less']
})
export class MostCommonChartComponent implements OnInit {
  @Input() title: string;
  @Input() subTitle = '';
  @Input() listCommonResponse: any[] = [];
  @Input() totalResponse: number;

  constructor() {
  }

  ngOnInit() {
    if (!this.listCommonResponse || !this.listCommonResponse.length) {
      this.listCommonResponse.push({answerName: 'No Data', answerPercentage: 0});
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/chart/most-common-chart/most-common-chart.component.ts